import Swiper from "swiper/bundle";
import "swiper/css/bundle";

document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".flex-layout.verhalen_slider-layout").forEach((layout) => {
        const swiperEl = layout.querySelector(".verhalen-swiper");
        if (!swiperEl) return;

        new Swiper(swiperEl, {
            loop: false,
            watchOverflow: true,
            navigation: {
                prevEl: layout.querySelector(".swiper-button-prev-custom"),
                nextEl: layout.querySelector(".swiper-button-next-custom"),
                disabledClass: "is-disabled",
            },
            keyboard: {
                enabled: true,
                onlyInViewport: true,
            },
            a11y: {
                enabled: true,
                prevSlideMessage: "Vorige",
                nextSlideMessage: "Volgende",
                slideLabelMessage: "Slide {{index}} van {{slidesLength}}",
            },
            breakpoints: {
                0: { slidesPerView: 1, spaceBetween: 12 },
                768: { slidesPerView: 1.5, spaceBetween: 16 },
                993: { slidesPerView: 2, spaceBetween: 16 },
            },
        });
    });
});
